export default {
  edit: {
    title: 'Edit Profile',
    subTitle: 'Edit Form',
    editInformation: 'Edit my information',
    sexOptionLabel: {
      male: 'Male',
      female: 'Female',
      unknown: 'Not specified'
    },
    notifyMessage: 'Changes saved'
  },
  changePassword: {
    title: 'Change my password',
    subTitle: 'Enter your old password. Then enter your new password twice.',
    lastPassword: 'Enter old password',
    newPassword: 'Enter new password',
    notifyMessage: 'Changes saved',
    notifyMessageError: 'Changes not saved, please check your password'
  }
}
